import { AppConfig } from './app-config';

/** An application configuration to be used in testing. */
export const testAppConfig: AppConfig = {
  theme: 'default',
  baseUrl: 'http://localhost:4200',
  assetsUrl: 'http://localhost:4200/assets'
};
